import { FC } from "react";
import { Box, Stack } from "@mui/material";
import { useToggle } from "rooks";
import { PieChartLegendItem } from "./PieChartLegendItem";
import { useHighchartsContext } from "../../common/components/HighchartsProvider";

interface HighChartPieChartLegendsProps {
  data: { name: string; y: number }[];
}

export const HighChartPieChartLegends: FC<HighChartPieChartLegendsProps> = ({
  data,
}) => {
  const { chartApi } = useHighchartsContext();
  const [updaterDependency, forceUpdate] = useToggle();

  return (
    <Stack flex={1} justifyContent="center" sx={stackStyles}>
      <Stack overflow="auto" maxWidth={350} minWidth={100}>
        {data.map(({ name, y }, index) => (
          <Box onClick={forceUpdate} key={name}>
            <PieChartLegendItem
              key={name}
              name={name}
              value={y ?? 0}
              chartApi={chartApi}
              bgcolor={index % 2 === 0 ? "grey.50" : "white"}
            />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

const stackStyles = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};
